import React from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import appConfig from "./config/appConfig";
import UserService from "./services/UserService";
import UserProfileService from "./services/UserProfileService";
import NotificationService from "./services/NotificationService";
import NavigationService from "./services/NavigationService";
import AccountAccessGate from "./components/auth/AccountAccessGate";
import Login from "./screens/Login";
import SellerRegistration from "./screens/SellerRegistration";
import demographic from "./screens/Dashboard/Demographic";
import ioT from "./screens/Dashboard/IoT";
import NavbarMenu from "./components/NavbarMenu";
import appInbox from "./screens/App/Inbox";
import appChat from "./screens/App/Chat";
import appCalendar from "./screens/App/Calendar";
import appContact from "./screens/App/Contact";
import appTaskbar from "./screens/App/Taskbar";
import filemanagerdashboard from "./screens/FileManager/Dashboard";
import filedocuments from "./screens/FileManager/Documents";
import filemedia from "./screens/FileManager/Media";
import fileimages from "./screens/FileManager/Images";
import blognewPost from "./screens/Blog/NewPost";
import blogdetails from "./screens/Blog/BlogDetails";
import bloglist from "./screens/Blog/BlogList";
import uitypography from "./screens/UIElements/Typography";
import uitabs from "./screens/UIElements/Tabs";
import uibuttons from "./screens/UIElements/Button";
import bootstrapui from "./screens/UIElements/BootstrapUI";
import uiicons from "./screens/UIElements/Icons";
import uinotifications from "./screens/UIElements/Notifications";
import uicolors from "./screens/UIElements/Colors";
import uilistgroup from "./screens/UIElements/ListGroup";
import uimediaobject from "./screens/UIElements/MediaObject";
import uimodal from "./screens/UIElements/Modals";
import uiprogressbar from "./screens/UIElements/ProgressBar";
import widgetsdata from "./screens/Widgets/Data";
import widgetsweather from "./screens/Widgets/Weather";
import widgetsblog from "./screens/Widgets/Blog";
import widgetsecommers from "./screens/Widgets/ECommers";
import registration from "./screens/Auth/Registration";
import lockscreen from "./screens/Auth/Lockscreen";
import forgotpassword from "./screens/Auth/ForgotPassword";
import page404 from "./screens/Auth/Page404";
import page403 from "./screens/Auth/Page403";
import page500 from "./screens/Auth/Page500";
import page503 from "./screens/Auth/Page503";
import blankpage from "./screens/Pages/BlankPage";
import profilev1page from "./screens/Pages/ProfileV1";
import profilev2page from "./screens/Pages/ProfileV2";
import imagegalleryprofile from "./screens/Pages/ImageGallery";
import timeline from "./screens/Pages/TimeLine";
import pricing from "./screens/Pages/Pricing";
import invoices from "./screens/Pages/Invoices";
import invoicesv2 from "./screens/Pages/InvoicesV2";
import searchresult from "./screens/Pages/SearchResults";
import helperclass from "./screens/Pages/HelperClass";
import teamsboard from "./screens/Pages/TeamsBoard";
import projectslist from "./screens/Pages/ProjectsList";
import maintanance from "./screens/Pages/Maintanance";
import testimonials from "./screens/Pages/Testimonials";
import faqs from "./screens/Pages/Faqs";
import formvalidation from "./screens/Forms/FormValidation";
import basicelements from "./screens/Forms/BasicElements";
import tablenormal from "./screens/Tables/TableNormal";
import echart from "./screens/Charts/Echart";
import leafletmap from "./screens/Maps/GoogleMaps";
import LeMieRichieste from "./screens/marketplace/requests/LeMieRichieste";
import DettaglioRichiestaCliente from "./screens/marketplace/requests/DettaglioRichiestaCliente";
import DashboardMarketPlace from "./screens/marketplace/dashboard/DashboardMarketPlace";
import RichiesteRicevute from "./screens/marketplace/seller/RichiesteRicevute";
import RichiestaDettaglioVenditore from "./screens/marketplace/seller/RichiestaDettaglioVenditore";
import SellerApprovals from "./screens/marketplace/admin/SellerApprovals";


window.__DEV__ = true;

class App extends React.Component {
  constructor(props) {
    console.warn = () => {}
    super(props);
    this.state = {
      isLoad: true,
      isProfileLoading: false,
      hasAttemptedProfileSync: false,
      isProfileModalVisible: false,
      currentUserProfile: null,
      profileSaveError: "",
      isProfileSaving: false,
      navigationMenu: [],
      notifications: [],
      unreadNotificationCount: 0,
    };
  }

  componentDidMount() {
    this.enforceRequestedPortalAccess();

    this.enforceRequestedPortalAccess();

    if (appConfig.auth.enableKeycloak && UserService.isLoggedIn()) {
      this.loadCurrentUserProfile();
      this.loadNavigationMenu();
      this.loadNotifications();
      this.startNotificationsPolling();
    }
  }

  componentDidUpdate() {
    this.enforceRequestedPortalAccess();

    this.enforceRequestedPortalAccess();

    if (
      appConfig.auth.enableKeycloak &&
      UserService.isLoggedIn() &&
      !this.state.isProfileLoading &&
      !this.state.currentUserProfile &&
      !this.state.hasAttemptedProfileSync
    ) {
      this.loadCurrentUserProfile();
    }

    if (appConfig.auth.enableKeycloak && UserService.isLoggedIn() && !this.notificationsInterval) {
      this.loadNavigationMenu();
      this.loadNotifications();
      this.startNotificationsPolling();
    }

    if (!UserService.isLoggedIn() && this.notificationsInterval) {
      window.clearInterval(this.notificationsInterval);
      this.notificationsInterval = null;
      if (this.state.notifications.length > 0 || this.state.unreadNotificationCount > 0) {
        this.setState({
          navigationMenu: [],
          notifications: [],
          unreadNotificationCount: 0,
        });
      }
    }
  }

  componentWillUnmount() {
    if (this.notificationsInterval) {
      window.clearInterval(this.notificationsInterval);
    }
  }

  enforceRequestedPortalAccess = () => {
    if (!appConfig.auth.enableKeycloak || !UserService.isLoggedIn()) {
      return;
    }

    const requestedPortal = UserService.getRequestedPortal();
    if (!requestedPortal) {
      return;
    }

    if (UserService.isPortalAllowed(requestedPortal)) {
      UserService.clearRequestedPortal();
      return;
    }

    const loginPathByPortal = {
      admin: "/admin/login?error=portal-mismatch",
      customer: "/login?role=customer&error=portal-mismatch",
      vendor: "/login?role=vendor&error=portal-mismatch",
    };

    UserService.doLogout({
      redirectPath: loginPathByPortal[requestedPortal] || "/login?error=portal-mismatch",
    });
  };

  loadCurrentUserProfile = async () => {
    this.setState({
      isProfileLoading: true,
      hasAttemptedProfileSync: true,
      profileSaveError: "",
    });

    try {
      const currentUserProfile = await UserProfileService.getMe();

      this.setState({
        currentUserProfile,
        isProfileLoading: false,
        isProfileModalVisible: !currentUserProfile.isProfileCompleted,
      });
    } catch (error) {
      this.setState({
        isProfileLoading: false,
        profileSaveError: "Impossibile caricare il profilo utente.",
      });
    }
  };

  onSaveFirstAccessProfile = async (payload) => {
    this.setState({
      isProfileSaving: true,
      profileSaveError: "",
    });

    try {
      const currentUserProfile = await UserProfileService.saveMe(payload);

      this.setState({
        currentUserProfile,
        isProfileModalVisible: false,
        isProfileSaving: false,
      });
    } catch (error) {
      this.setState({
        isProfileSaving: false,
        profileSaveError:
          error?.response?.data?.detail || "Salvataggio profilo non riuscito.",
      });
    }
  };

  startNotificationsPolling = () => {
    if (this.notificationsInterval) {
      window.clearInterval(this.notificationsInterval);
    }

    this.notificationsInterval = window.setInterval(() => {
      if (UserService.isLoggedIn()) {
        this.loadNotifications();
      }
    }, 60000);
  };

  loadNavigationMenu = async () => {
    try {
      const navigationMenu = await NavigationService.listMenu();
      this.setState({ navigationMenu });
    } catch (error) {
      this.setState({ navigationMenu: [] });
    }
  };

  loadNotifications = async () => {
    try {
      const notifications = await NotificationService.list();
      this.setState({
        notifications,
        unreadNotificationCount: NotificationService.getUnreadCount(notifications),
      });
    } catch (error) {
      this.setState({
        notifications: [],
        unreadNotificationCount: 0,
      });
    }
  };

  onNotificationClick = async (notification) => {
    const notificationId = typeof notification === "string" ? notification : notification?.id;
    const notificationLink = typeof notification === "object" && notification?.link ? notification.link : "";

    if (notificationId) {
      try {
        await NotificationService.markAsRead([notificationId]);
        this.setState((previousState) => {
          const notifications = previousState.notifications.map((item) =>
            item.id === notificationId ? { ...item, read: true } : item
          );

          return {
            notifications,
            unreadNotificationCount: NotificationService.getUnreadCount(notifications),
          };
        });
      } catch (error) {
        // keep current state on write failures
      }
    }

    if (notificationLink) {
      const refreshAt = Date.now();
      const normalizedLink = notificationLink.startsWith("/")
        ? notificationLink
        : "/" + notificationLink;
      this.props.history.push({
        pathname: (process.env.PUBLIC_URL || "") + normalizedLink,
        state: {
          refreshSellerApprovalsAt: refreshAt,
          notificationId: notificationId || null,
        },
      });
    }
  };

  onMarkAllNotificationsRead = async () => {
    try {
      await NotificationService.markAllAsRead(this.state.notifications);
      this.setState((previousState) => ({
        notifications: previousState.notifications.map((item) => ({
          ...item,
          read: true,
        })),
        unreadNotificationCount: 0,
      }));
    } catch (error) {
      // keep current state on write failures
    }
  };

  render() {

    var res = window.location.pathname;
    var baseUrl = process.env.PUBLIC_URL;
    baseUrl = baseUrl.split("/");
    res = res.split("/");
    res = res.length > 0 ? res[baseUrl.length] : "/";
    res = res ? res : "/";
    const activeKey1 = res;
    const isAuthRoute =
      activeKey1 === "" ||
      activeKey1 === "/" ||
      activeKey1 === "login" ||
      activeKey1 === "registration" ||
      activeKey1 === "lockscreen" ||
      activeKey1 === "forgotpassword" ||
      activeKey1 === "page404" ||
      activeKey1 === "page403" ||
      activeKey1 === "page500" ||
      activeKey1 === "page503" ||
      activeKey1 === "maintanance" ||
      (activeKey1 === "admin" && window.location.pathname.endsWith("/admin/login"));
    const requiresKeycloak = appConfig.auth.enableKeycloak;
    const isAuthenticated = UserService.isLoggedIn();
    const isSeller = isAuthenticated && UserService.isSeller();
    const isAdmin = isAuthenticated && UserService.isAdmin();
    const shouldBlockForVerification =
      isAuthenticated &&
      this.state.currentUserProfile &&
      (!this.state.currentUserProfile.emailVerified ||
        (isSeller && !this.state.currentUserProfile.isSellerApproved));
    const showAuthRoutes = requiresKeycloak && !isAuthenticated;
    const activeNavKey = activeKey1 === "/" || activeKey1 === "" ? "dashboard" : activeKey1;
    const showMarketplaceHeader =
      activeNavKey === "dashboard" || activeNavKey === "/";
    const authMainContentStyle = showAuthRoutes
      ? showMarketplaceHeader
        ? { width: "100%", marginLeft: 0 }
        : {
            width: "100%",
            marginLeft: 0,
            marginTop: 0,
            padding: 0,
            float: "none",
            minHeight: "100vh",
          }
      : { width: "100%", marginLeft: 0 };

    return (
      <div id="wrapper">
        {showAuthRoutes ? (
          <>
            {showMarketplaceHeader ? (
              <NavbarMenu
                history={this.props.history}
                activeKey={activeNavKey}
                headerOnly={true}
                showVendorLogin={!isAuthenticated}
              />
            ) : null}
            <div
              id="main-content"
              className={showMarketplaceHeader ? "marketplace-dashboard-main" : ""}
              style={authMainContentStyle}
            >
              <Switch>
                {/* <Route exact path={`${process.env.PUBLIC_URL}`} component={Login} /> */}
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/`}
                  component={DashboardMarketPlace}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/dashboard`}
                  component={DashboardMarketPlace}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/login`}
                  component={Login}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/admin/login`}
                  component={Login}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/seller-registration`}
                  component={SellerRegistration}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/forgotpassword`}
                  component={forgotpassword}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/page404`}
                  component={page404}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/page403`}
                  component={page403}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/page500`}
                  component={page500}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/page503`}
                  component={page503}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/registration`}
                  component={registration}
                />
                <Route exact path={`registration`} component={registration} />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/lockscreen`}
                  component={lockscreen}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/maintanance`}
                  component={maintanance}
                />
                {!isAuthRoute ? (
                  <Redirect to={`${process.env.PUBLIC_URL}/dashboard`} />
                ) : null}
              </Switch>
            </div>
          </>
        ) : shouldBlockForVerification ? (
          <AccountAccessGate
            profile={this.state.currentUserProfile}
            isSeller={isSeller}
          />
        ) : (
          <>
              {isSeller ? (
                <>
                  <NavbarMenu
                    history={this.props.history}
                    activeKey={activeNavKey}
                    topbarOnly={false}
                    sellerMode={true}
                    isAdmin={isAdmin}
                    dynamicMenu={this.state.navigationMenu}
                    notifications={this.state.notifications}
                    unreadNotificationCount={this.state.unreadNotificationCount}
                    onNotificationClick={this.onNotificationClick}
                    onMarkAllRead={this.onMarkAllNotificationsRead}
                  />
                  <div
                    id="main-content"
                    style={{
                      width: "100%",
                      marginLeft: 0,
                      marginTop: 67,
                      padding: 0,
                      float: "none",
                      minHeight: "calc(100vh - 67px)",
                    }}
                  >
                    <Switch>
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/`}
                        render={() => (
                          <Redirect
                            to={`${process.env.PUBLIC_URL}/seller-richieste`}
                          />
                        )}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/dashboard`}
                        render={() => (
                          <Redirect
                            to={`${process.env.PUBLIC_URL}/seller-richieste`}
                          />
                        )}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/seller-richieste`}
                        render={(routeProps) => <RichiesteRicevute {...routeProps} showStorico={false} />}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/seller-storico`}
                        render={(routeProps) => <RichiesteRicevute {...routeProps} showStorico={true} />}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/seller/richieste-ricevute`}
                        render={(routeProps) => <RichiesteRicevute {...routeProps} showStorico={false} />}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/seller/storico-richieste`}
                        render={(routeProps) => <RichiesteRicevute {...routeProps} showStorico={true} />}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/seller/richieste-ricevute/storico`}
                        render={(routeProps) => <RichiesteRicevute {...routeProps} showStorico={true} />}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/seller-richieste/:richiestaId`}
                        component={RichiestaDettaglioVenditore}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/seller/richieste-ricevute/:richiestaId`}
                        component={RichiestaDettaglioVenditore}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/profilev2page`}
                        component={profilev2page}
                      />
                      {isAdmin ? (
                        <Route
                          exact
                          path={`${process.env.PUBLIC_URL}/admin/venditori`}
                          component={SellerApprovals}
                        />
                      ) : null}
                      <Redirect
                        to={`${process.env.PUBLIC_URL}/seller-richieste`}
                      />
                    </Switch>
                  </div>
                </>
              ) : (
                <>
                  <NavbarMenu
                    history={this.props.history}
                    activeKey={activeNavKey}
                    isAdmin={isAdmin}
                    dynamicMenu={this.state.navigationMenu}
                    notifications={this.state.notifications}
                    unreadNotificationCount={this.state.unreadNotificationCount}
                    onNotificationClick={this.onNotificationClick}
                    onMarkAllRead={this.onMarkAllNotificationsRead}
                  />
                  <div id="main-content">
                    <Switch>
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/`}
                        render={() => <Redirect to={`${process.env.PUBLIC_URL}/dashboard`} />}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/login`}
                        render={() => <Redirect to={`${process.env.PUBLIC_URL}/dashboard`} />}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/dashboard`}
                        component={DashboardMarketPlace}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/demographic`}
                        component={demographic}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/ioT`}
                        component={ioT}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/appinbox`}
                        component={appInbox}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/appchat`}
                        component={appChat}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/appcalendar`}
                        component={appCalendar}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/appcontact`}
                        component={appContact}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/apptaskbar`}
                        component={appTaskbar}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/filemanagerdashboard`}
                        component={filemanagerdashboard}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/filedocuments`}
                        component={filedocuments}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/filemedia`}
                        component={filemedia}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/fileimages`}
                        component={fileimages}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/blognewpost`}
                        component={blognewPost}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/blogdetails`}
                        component={blogdetails}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/bloglist`}
                        component={bloglist}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/uitypography`}
                        component={uitypography}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/uitabs`}
                        component={uitabs}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/bootstrapui`}
                        component={bootstrapui}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/uiicons`}
                        component={uiicons}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/uinotifications`}
                        component={uinotifications}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/uicolors`}
                        component={uicolors}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/uilistgroup`}
                        component={uilistgroup}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/uimediaobject`}
                        component={uimediaobject}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/uimodal`}
                        component={uimodal}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/uibuttons`}
                        component={uibuttons}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/uiprogressbar`}
                        component={uiprogressbar}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/widgetsdata`}
                        component={widgetsdata}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/widgetsweather`}
                        component={widgetsweather}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/widgetsblog`}
                        component={widgetsblog}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/widgetsecommers`}
                        component={widgetsecommers}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/blankpage`}
                        component={blankpage}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/profilev1page`}
                        component={profilev1page}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/profilev2page`}
                        component={profilev2page}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/imagegalleryprofile`}
                        component={imagegalleryprofile}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/timeline`}
                        component={timeline}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/pricing`}
                        component={pricing}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/invoices`}
                        component={invoices}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/invoicesv2`}
                        component={invoicesv2}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/searchresult`}
                        component={searchresult}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/helperclass`}
                        component={helperclass}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/teamsboard`}
                        component={teamsboard}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/projectslist`}
                        component={projectslist}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/testimonials`}
                        component={testimonials}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/faqs`}
                        component={faqs}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/formvalidation`}
                        component={formvalidation}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/basicelements`}
                        component={basicelements}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/tablenormal`}
                        component={tablenormal}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/echart`}
                        component={echart}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/leafletmap`}
                        component={leafletmap}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/richieste`}
                        render={(routeProps) => <LeMieRichieste {...routeProps} showStorico={false} />}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/storico-richieste`}
                        render={(routeProps) => <LeMieRichieste {...routeProps} showStorico={true} />}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/richieste/storico`}
                        render={(routeProps) => <LeMieRichieste {...routeProps} showStorico={true} />}
                      />
                      <Route
                        exact
                        path={`${process.env.PUBLIC_URL}/richieste/:richiestaId`}
                        component={DettaglioRichiestaCliente}
                      />
                      {isAdmin ? (
                        <Route
                          exact
                          path={`${process.env.PUBLIC_URL}/admin/venditori`}
                          component={SellerApprovals}
                        />
                      ) : null}
                    </Switch>
                  </div>
                </>
              )}
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ loginReducer }) => ({
  isLoggedin: loginReducer.isLoggedin,
});

export default withRouter(connect(mapStateToProps, {})(App));


























